// Editable fields from the supplied Lookup Controller contract.
const fields = [
    {
        "name": "name",
        "label": "Name",
        "type": "text",
        "required": true
    },
    {
        "name": "abbreviation",
        "label": "Abbreviation",
        "type": "text",
        "required": true
    },
    {
        "name": "commodityIcon",
        "label": "Commodity icon",
        "type": "commodity-icon",
        "required": false
    },
    {
        "name": "commodityColor",
        "label": "Commodity color",
        "type": "color",
        "required": false
    },
    {
        "name": "isProcurement",
        "label": "Procurement",
        "type": "checkbox",
        "required": false
    },
    {
        "name": "hasRevenueForecast",
        "label": "Revenue forecast",
        "type": "checkbox",
        "required": false
    }
];

export default fields;
